import { useInfiniteQuery } from 'react-query'

import { fetchEventsByGroupIds } from 'utils/queries'

import { Event } from 'types/event'

export const useGroupEvents = ({
  groupIds,
  eventObject = 'all',
  limit = 10,
}: {
  groupIds: string[]
  eventObject?: 'post' | 'all'
  limit?: number
}) => {
  return useInfiniteQuery<Array<Event>>(
    ['groupEvents', eventObject, [...groupIds]],
    ({ pageParam }) =>
      fetchEventsByGroupIds(
        { groupIds, eventObject },
        { order: 'created', orderDirection: 'desc', lastVisible: pageParam, limit },
      ),
    {
      // refetchOnMount: 'always',
      // refetchOnWindowFocus: 'always',
      getNextPageParam: (lastPage) => {
        // Very important, as the last page might not have any results
        if (!lastPage || !lastPage.length) return undefined

        return lastPage[lastPage.length - 1].created
      },
    },
  )
}
